import { StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { Colors } from '@/constants/theme';
import { BorderRadius, Spacing } from '@/constants/spacing';
import { useColorScheme } from '@/hooks/use-color-scheme';

type MapExpandButtonProps = {
  onPress: () => void;
};

/**
 * Subtle expand chip in the top-right corner of a static map — the only
 * tap target on the home minimap; opens the full-screen route map.
 */
export function MapExpandButton({ onPress }: MapExpandButtonProps) {
  const colorScheme = useColorScheme();
  const palette = Colors[colorScheme ?? 'light'];

  return (
    <TouchableOpacity
      style={[styles.chip, { backgroundColor: palette.cardBackground }]}
      onPress={onPress}
      activeOpacity={0.7}
      hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      accessibilityLabel="Open full-screen route map"
    >
      <Ionicons name="expand-outline" size={14} color={palette.textMuted} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  chip: {
    position: 'absolute',
    top: Spacing.xs,
    right: Spacing.xs,
    padding: Spacing.xxs,
    borderRadius: BorderRadius.sm,
    opacity: 0.92,
    shadowColor: '#000',
    shadowOpacity: 0.15,
    shadowRadius: 3,
    shadowOffset: { width: 0, height: 1 },
    elevation: 2,
  },
});
